"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const sanitize_html_1 = __importDefault(require("sanitize-html"));
/**
 *
 *  New Rules needs to be reviewed by InfoSec team
 *
 *  For sanitize options see:
 *  https://github.com/punkave/sanitize-html#what-are-the-default-options
 *
 *  Example:
 *
 *  const customSanitizeOptions = {
 *      allowedTags: ['span'],
 *
 *      allowedAttributes: {
 *          a: ['href', 'name', 'target']
 *      },
 *
 *      ...
 *  }
 *
 *  NOTE: please rememember to Add default configuration from sanitizeHtml
 *
 * */
const customSanitizeOptions = {
    // Add new rules here
    allowedTags: [
        ...sanitize_html_1.default.defaults.allowedTags,
        'span'
    ],
    allowedAttributes: Object.assign(Object.assign({}, sanitize_html_1.default.defaults.allowedAttributes), { span: ['class'] })
};
/*
 *
 *  Safe Html - a wrapper which sanitizes the dangerouslySetInnerHTML content
 *  to prevent XSS
 *
 */
class SafeHtml extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.getHtml = () => {
            const { dangerouslySetInnerHTML } = this.props;
            const { __html } = dangerouslySetInnerHTML;
            return __html;
        };
        this.sanitize = (htmlString) => {
            const sanitizeOptions = Object.assign(Object.assign({}, sanitize_html_1.default.defaults), customSanitizeOptions);
            const safeHtml = (0, sanitize_html_1.default)(htmlString, sanitizeOptions);
            return safeHtml;
        };
        this.removeInternalProps = (props) => {
            const newProps = props;
            delete newProps.element;
            return newProps;
        };
        this.getHtmlSafeProps = (props) => {
            const newProps = Object.assign({}, props);
            const { dangerouslySetInnerHTML } = newProps;
            const __html = this.getHtml();
            if (dangerouslySetInnerHTML && __html) {
                dangerouslySetInnerHTML.__html = this.sanitize(__html);
            }
            return this.removeInternalProps(newProps);
        };
    }
    render() {
        const { element } = this.props;
        let safeElement = null;
        try {
            if (element) {
                safeElement = react_1.default.createElement(element, this.getHtmlSafeProps(this.props), null);
            }
        }
        catch (e) {
            console.warn('[SafeHtml] Error creating React.createElement with element. ', e);
        }
        return safeElement;
    }
}
SafeHtml.propTypes = {
    element: prop_types_1.default.string,
    dangerouslySetInnerHTML: prop_types_1.default.object
};
SafeHtml.defaultProps = {
    element: '',
    dangerouslySetInnerHTML: { __html: '' }
};
exports.default = SafeHtml;
//# sourceMappingURL=SafeHtml.js.map